import moment from 'moment';

export const DEFAULT_TIME_RANGE = {
  start: moment().startOf('year'),
  end: moment().endOf('year'),
};
